exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1nyDfR25DdQo4MfBcIcs8r {\n  border-radius: 50%;\n  background: var(--primary-base-color);\n  width: 0.8em;\n  height: 0.8em;\n}\n\n.q4brJa3WdlQuOK2vjrx5k {\n  display: inline-flex;\n  align-self: center;\n  vertical-align: middle;\n  max-height: 0.5em;\n  max-width: 0.5em;\n  margin-left: 0.4em;\n}\n\n._2XapELFzLff4TuvnE-NE9B {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n", ""]);

// Exports
exports.locals = {
	"unreadNotificationIcon": "_1nyDfR25DdQo4MfBcIcs8r",
	"center": "q4brJa3WdlQuOK2vjrx5k",
	"topRight": "_2XapELFzLff4TuvnE-NE9B"
};